import React from "react";
import { Input, Label, Row } from "reactstrap";
import { ColValue } from "../ProductionModule/index";
import { ColPrompt } from "./index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by Heli KV2008B and Heli KV2019B machines

export default function CounterSwitchRow() {
   const { onChange, onChangeErrorDivDefinitions } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   return (
      <Row className="mb-2">
         <ColPrompt title={"Counter Switch"} bold={true} description={""} sizeProp={6} />
         <ColValue size={6}>
            <Label className="me-4">
               <Input
                  type="radio"
                  name="counterSwitch"
                  value={"true"}
                  checked={machineSetup.extendedPropertyJson.counterSwitch === true || machineSetup.extendedPropertyJson.counterSwitch === "true"}
                  onChange={(e) => {
                     onChange("extendedPropertyJson.counterSwitch", e.target.value)
                     if (errorDivDefinitions?.counterSwitch) onChangeErrorDivDefinitions("counterSwitch", false);
                  }}
               />
               Active
            </Label>
            <Label className="me-2">
               <Input
                  type="radio"
                  name="counterSwitch"
                  value={"false"}
                  checked={machineSetup.extendedPropertyJson.counterSwitch === false || machineSetup.extendedPropertyJson.counterSwitch === "false"}
                  onChange={(e) => {
                     onChange("extendedPropertyJson.counterSwitch", e.target.value)
                     if (errorDivDefinitions?.counterSwitch) onChangeErrorDivDefinitions("counterSwitch", false);
                  }}
               />
               Closed
            </Label>
         </ColValue>
      </Row>
   );
}
